import ItemTransactionsDashboard from './ItemTransactionsDashboardContainer';

export default ItemTransactionsDashboard;
